import Panel from '@/components/ui/box/Panel';
import Paper from '@/components/ui/box/Paper';

export type JumbotronPanelProps = React.PropsWithChildren<{
  panelHeaderTitle?: string;
}>;

const JumbotronPanel: React.FC<JumbotronPanelProps> = ({
  panelHeaderTitle,
  children,
}) => (
  <Paper flex flexItemWide>
    <Panel title={panelHeaderTitle} strongHeader centerBody>
      {children}
    </Panel>
  </Paper>
);

export default JumbotronPanel;
